// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let Discount
export default Discount = class Discount extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {
  url() {
    const {
      resource_id,
      offering_id,
      license_offering_id,
      seat_count,
      discount_code
    } = this.toJSON()
    // No offering_id if this is group option
    let offeringOrLicenseOfferingHash = ""
    let seatCountParam = ""
    if (offering_id) {
      offeringOrLicenseOfferingHash = `offering/${offering_id}/`
    }
    if (license_offering_id) {
      offeringOrLicenseOfferingHash = `license-offering/${license_offering_id}/`
    }
    if (seat_count != null) {
      seatCountParam = `?seat_count=${seat_count}`
    }
    return this.urlRoot(
      `/api/private/library/resource/${resource_id}/${offeringOrLicenseOfferingHash}discount/${discount_code}/${seatCountParam}`
    )
  }
}
